import { Message } from '../../types/rest'
import * as events from '../../api/socket/types'
import { INITIALIZE_MESSAGES } from './types'

export const initializeMessages = (payload: Message[]) => ({ type: INITIALIZE_MESSAGES, payload })
export const addMessage = (payload: Message) => ({ type: events.meeting_got_new_message, payload })
export const removeMessage = (payload: string) => ({ type: events.meeting_message_deleted, payload })
